<div class="wrap">
  <div class="con" *ngIf="alertData">
    <div class="txt_area">
      <p>{{ message }}</p>
      <p class="sub_message" *ngIf="subMessage">
        {{ subMessage }}
      </p>
      <div class="time_area" *ngIf="type == 'moreTime'">
        <!--ng class 확인해주세요-->
        <button (click)="clickEvent(3)" [ngClass]="{ btn_ac: addTime1 }">
          03:00
        </button>
        <button (click)="clickEvent(5)" [ngClass]="{ btn_ac: addTime2 }">05:00</button>
        <button (click)="clickEvent(8)" [ngClass]="{ btn_ac: addTime3 }">08:00</button>
        <button (click)="clickEvent(10)" [ngClass]="{ btn_ac: addTime4 }">10:00</button>
        <button (click)="clickEvent(15)" [ngClass]="{ btn_ac: addTime5 }">15:00</button>
        <button (click)="clickEvent(20)" [ngClass]="{ btn_ac: addTime6 }">20:00</button>
      </div>
    </div>
    <div class="btn_wrap" *ngIf="type !== 'leftOk'">
      <button class="cancel_btn left_cancel" (click)="close('cancel')">
        {{ cancelButton ? cancelButton : "취소" }}
      </button>
      <button (click)="close('ok')">{{ okButton ? okButton : "확인" }}</button>
    </div>
    <div class="btn_wrap" *ngIf="type == 'leftOk'">
      <button (click)="close('ok')">확인</button>
      <button class="cancel_btn right_cancel" (click)="close('cancel')">
        취소
      </button>
    </div>
  </div>

  <!--아이디 확인-->
  <!-- <div class="con" *ngIf="type == 'canId'">
        <div class="txt_area">
        <p>사용 가능한 아이디입니다.</p>
        </div>
        <div class="btn_wrap">
            <button class="cancel_btn" (click)="close('cancel')">취소</button>
            <button (click)="close('ok')">사용하기</button>
        </div>
    </div> -->

  <!--플레이 나가기-->
  <!-- <div class="con" *ngIf="type == 'exitPlay'">
        <div class="txt_area">
            <p>플레이를 종료 하시겠습니까?</p>
        </div>
        <div class="btn_wrap">
            <button (click)="close('playExit')" [routerLink]="[ '/home' ]">확인</button>
            <button class="cancel_btn" (click)="close('playCancel')">취소</button>
        </div>
    </div> -->

  <!--보드에서 문장 선택-->
  <!-- <div class="con" *ngIf="type == 'pickSentence'"> -->
  <!--선택한 문장 제출-->
  <!-- <div class="can">
        <div class="txt_area">
            <p>선택한 문장을 보드에 제출하시겠습니까?</p>
        </div>
        <div class="btn_wrap">
            <button class="cancel_btn left_cancel" (click)="close()">취소</button>
            <button (click)="close()">확인</button>
        </div>
        </div> -->

  <!--선택 문장 변경-->
  <!-- <div class="can txt_center">
        <div class="txt_area">
            <p>제출 문장을 변경하시면 <br>좋아요와 댓글이 모두 삭제됩니다. <br>변경하시겠습니까?</p>
        </div>
        <div class="btn_wrap">
            <button class="cancel_btn left_cancel" (click)="close()">취소</button>
            <button (click)="close()">확인</button>
            
        </div>
        </div> -->

  <!--5개 이하의 보드가 잇을때 아닐때 -->
  <!-- <div class="cant">
        <div class="txt_area">
            <p>최소 5번 이상 플레이 진행 후 제출 가능합니다.</p>
        </div>
        <div class="btn_wrap">
            <button (click)="close()">확인</button>
        </div>
        </div> -->
  <!-- </div> -->

  <!--댓글란 욕설 댓글 등록시 alert-->
  <!-- <div class="con" *ngIf="type == 'cantComment'">
        <div class="cant">
        <div class="txt_area">
            <p>욕설을 입력할 수 없습니다.</p>
        </div>
        <div class="btn_wrap">
            <button (click)="close()">확인</button>
        </div>
        </div>
    </div> -->

  <!--댓글 삭제 클릭시 alert-->

  <!-- <div class="con" *ngIf="type == ''">
        <div class="can">
        <div class="txt_area">
            <p>작성한 댓글을 삭제하시겠습니까?</p>
        </div>
        <div class="btn_wrap">
            <button class="cancel_btn left_cancel" (click)="close()">취소</button>
            <button (click)="close()">확인</button>
        </div> -->

  <!--댓글란 신고댓글 클릭 시 alert-->
  <!--댓글 신고-->
  <!-- <div class="con" *ngIf="type == ''">
        <div class="can">
        <div class="txt_area">
            <p>댓글을 신고하시겠습니까?</p>
        </div>
        <div class="btn_wrap">
            <button class="cancel_btn left_cancel" (click)="close()">취소</button>
            <button (click)="close()">확인</button>
        </div> -->

  <!--댓글 신고 후-->
  <!-- <div class="cant">
        <div class="txt_area">
            <p>해당 댓글이 신고되었습니다.</p>
        </div>
        <div class="btn_wrap">
            <button (click)="close('check')">확인</button>
        </div>
        </div>
    </div> -->
</div>
